<template>
  <div id="app">
    <headers></headers>
    <div class="teaching-list">
      <div class="w_1400">
        <div class="previous-page">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>

        <div class="teaching-list-left">
          <div class="teaching-list-user" v-if="userinfo">
            <p>
              <img :src="userinfo.avatar" alt="">
            </p>
            <h1>{{userinfo.nickname}}</h1>
          </div>

          <div class="teaching-list-nav">
            <h3>我的教学</h3>
            <ul>
              <li class="active">
                <router-link to="/homecourse"><a href="javascript();">在教课程</a></router-link>
              </li>
              <li>
                <router-link to="/homework"><a href="javascript();">课程作业</a></router-link>
              </li>
              <li>
                <router-link to="/practice"><a href="javascript();">实践作业</a></router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="teaching-list-right">
          <h3>在教课程</h3>

          <div class="teaching-list-form">
            <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">

              <template slot="prepend">
                <i class="el-icon-search"></i>
              </template>

              <el-button type="success" size="mini" slot="suffix">搜索</el-button>
            </el-input>
          </div>

          <div class="teaching-list-table homework-table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="id" label="编号" width="220">
              </el-table-column>
              <el-table-column prop="name" label="课程标题" width="220">
              </el-table-column>
              <el-table-column prop="time" label="发布时间">
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="correction(scope.$index, tableData)" type="text" size="small">
                    查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;">
              <el-pagination layout="prev, pager, next" :total="total" :page-size="10" @next-click="nextpage"
                @prev-click="prevpage" @current-change="currentchange">
              </el-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    allcourse
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        tableData: [],
        search: '',
        userinfo: '',
        total: 0,
        index1: 0,
        page: 1,
      }
    },
    methods: {
      // 打开课程详情页面
      correction(index, rows) {

        this.$router.push({
          name: 'courseshow',
          query: {
            id: this.tableData[index].id
          }
        })
      },
      // 点击了下一页时触发的方法
      nextpage() {
        this.page++
        this.allcourses()
      },
      // 点击了上一页时触发的方法
      prevpage() {
        this.page--
        this.allcourses()
      },
      // page被改变时触发的方法
      currentchange(event) {
        this.page = event
        this.allcourses()
      },
      //获取所有课程
      allcourses() {
        let self = this
        allcourse({
          'page': this.page,
          'pageSize': 10
        }).then(res => {
          this.tableData = res.data.data.map(item => {
            item.time = self.timestampToTime(item.createtime)
            return item;
          })
          this.total = res.data.total
        })
      },
      //时间戳转日期格式
      timestampToTime(timestamp) {
        // 时间戳为10位需*1000，时间戳为13位不需乘1000
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + ".";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D;
      }
    },
    created() {
      this.allcourses();
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    }
  }
</script>

<style>
  @import '../../assets/css/home.css';

  .el-button--small {
    width: 99.86px;
    height: 28.04px;
    background: #80D676;
    border-radius: 3.116px;
    color: #FDFDFD;
  }

  .el-input {
    width: 330px;
  }

  .el-input-group--prepend .el-input__inner {
    border: none;
  }

  .input-with-select .el-input-group__prepend {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/homecourse.vue